import type { HelpFile } from '../../types/help'
import { SchemaTestIds } from '../../../testids/SchemaTestIds'

export const schemaHelp: HelpFile = {
  docPage: '/docs/schema/overview',
  texts: {
    [SchemaTestIds.schemaWelcomeCard]:
      'Schema section landing page — pick a tool from the sidebar: types, attribute definitions, form layouts, relationship schema, and value lists.',
  },
}
